var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18IcRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9497475,4.05025253 C16.6820081,6.78251313 16.6820081,11.2174869 13.9497475,13.9497475 C11.2174869,16.6820081 6.78251313,16.6820081 4.05025253,13.9497475 C1.31799193,11.2174869 1.31799193,6.78251313 4.05025253,4.05025253 C6.78251313,1.31799193 11.2174869,1.31799193 13.9497475,4.05025253 Z M10.979899,11.9698485 L11.9698485,10.979899 L9.98994949,9 L11.9698485,7.02010101 L10.979899,6.03015152 L9,8.01005051 L7.02010101,6.03015152 L6.03015152,7.02010101 L8.01005051,9 L6.03015152,10.979899 L7.02010101,11.9698485 L9,9.98994949 L10.979899,11.9698485 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18IcRemove);
export default __webpack_public_path__ + "static/media/18_ic_remove.bde16c8a.svg";
export { ForwardRef as ReactComponent };